import { render, staticRenderFns } from "./_404.vue?vue&type=template&id=a14d8004&scoped=true"
import script from "./_404.vue?vue&type=script&lang=js"
export * from "./_404.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a14d8004",
  null
  
)

export default component.exports